import { Colors, Icon, Pills } from '@amelio/ui-library';

import {
    FEEDBACK_PRIVACY_ICONS,
    FEEDBACK_PRIVACY_LABEL_KEYS,
    isAnonymousFeedback,
    type FeedbackPrivacyValue,
} from '@/constants/review/FeedbackPrivacy';
import { useAmelioTranslations } from '@/hooks';

interface FeedbackPrivacyPillProps {
    feedbackPrivacy: FeedbackPrivacyValue;
}

/**
 * The mode of a 360 as a label, with no explanation of its own: `FeedbackSettingsPills` explains
 * it on hover, and a card that is itself a link shows it bare, where a focusable tooltip cannot go.
 */
export const FeedbackPrivacyPill = ({ feedbackPrivacy }: FeedbackPrivacyPillProps) => {
    const { t } = useAmelioTranslations();
    const label = t(FEEDBACK_PRIVACY_LABEL_KEYS[feedbackPrivacy]);

    if (isAnonymousFeedback(feedbackPrivacy)) {
        return (
            <Pills
                variant={'lightPurple'}
                size={'sm'}
            >
                {label}
            </Pills>
        );
    }

    return (
        <Pills
            variant={'warning'}
            size={'sm'}
        >
            <span className={'inline-flex items-center gap-1'}>
                <Icon
                    name={FEEDBACK_PRIVACY_ICONS[feedbackPrivacy]}
                    size={'sm'}
                    color={Colors.WARNING_900}
                    ariaHidden
                />

                {label}
            </span>
        </Pills>
    );
};
